import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ArrowRight, Check } from 'lucide-react';
const ServiceModal = ({ service, isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}
          onClick={onClose}
          className="fixed inset-0 lg:left-16 z-40 bg-black/30 flex items-center justify-center"
        >
          {/* Bouton fermeture dans la modale, position absolute, hors du scroll */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 40 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 40 }}
            transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}
            className="max-w-2xl w-[95vw] lg:w-[calc(95vw-64px)] max-h-[90vh] z-50 rounded-3xl border border-white/30 shadow-2xl relative px-0 py-0 md:px-0 md:py-0 backdrop-blur-2xl bg-gray-700/60 ring-2 ring-white/20"
            style={{ background: 'rgba(55,65,81,0.55)', color: '#22272a', backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)', boxShadow: '0 8px 32px 0 rgba(30,41,59,0.18), inset 0 1px 8px 0 rgba(255,255,255,0.25)', borderRadius: '2rem', border: '1.5px solid rgba(255,255,255,0.35)', zIndex: 2, position: 'relative' }}
            onClick={e => e.stopPropagation()}
          >
            <button
              onClick={onClose}
              className="absolute top-6 right-6 p-2 hover:bg-gray-800 rounded-xl transition-all z-50"
              style={{ background: 'rgba(36, 41, 56, 0.7)', position: 'absolute', top: '1.5rem', right: '1.5rem', zIndex: 50 }}
            >
              <X size={24} className="text-gray-400 hover:text-white" />
            </button>
            <div className="overflow-y-auto max-h-[90vh] rounded-3xl px-6 py-8 md:px-10 md:py-12 custom-scrollbar" style={{borderRadius: '2rem'}}>
              {/* Icône */}
              {service.icon && (
                <div className="mb-6">
                  <div className={`w-16 h-16 rounded-2xl flex items-center justify-center ${service.bgColor}`}>
                    <service.icon size={32} className="text-white" />
                  </div>
                </div>
              )}
              {/* Titre et description */}
              <h2 className="text-3xl font-montserrat font-bold text-white mb-6">
                {service.title}
              </h2>
              <p className="text-gray-300 text-lg leading-relaxed mb-8">
                {service.fullDescription}
              </p>
              {/* Avantages */}
              {service.benefits && (
                <div className="mb-10">
                  <h3 className="font-montserrat font-bold text-white text-lg mb-4">
                    Ce que vous obtenez :
                  </h3>
                  <ul className="space-y-4">
                    {service.benefits.map((benefit, idx) => (
                      <li key={idx} className="flex items-start space-x-3">
                        <Check className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" />
                        <span className="text-gray-300">{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {/* Cas d'usage */}
              {service.useCases && (
                <div className="mb-10">
                  <h3 className="font-montserrat font-bold text-white text-lg mb-4">
                    Idéal pour :
                  </h3>
                  <div className="grid grid-cols-2 gap-4">
                    {service.useCases.map((useCase, idx) => (
                      <div
                        key={idx}
                        className="p-3 rounded-lg bg-gray-800/50 border border-gray-700 text-gray-300 text-sm"
                      >
                        {useCase}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-6 mt-8">
                <a
                  href="#contact"
                  onClick={onClose}
                  className="flex-1 px-8 py-4 rounded-xl bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900 text-white font-montserrat font-semibold transition-all flex items-center justify-center space-x-2 shadow-lg"
                >
                  <span>Être rappelé</span>
                  <ArrowRight size={18} />
                </a>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export { ServiceModal };
export default ServiceModal;
